import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './DiagnosisMore.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import { useLocation, useNavigate } from 'react-router-dom';

import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';

import ToastPopup from '../../../../../components/comm/ToastPopup';

const PAGE_SIZE = 30;

const DiagnosisMore = () => {
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const location = useLocation();
    const navigate = useNavigate();
    const [dgnssList, setDgnssList] = useState([]); //주요 진단
    const [pageNo, setPageNo] = useState(1);
    const [hasNext, setHasNext] = useState(true);

    const observerRef = useRef(null);
    const scrollObserver = useRef(null);
    const isFirstApiCalled = useRef(false);


    // 결과 호출
    const retrieveUsrDgnssList = useCallback(async (pageNo) => {
        const url = "/mypage/retrieveUsrDgnssList";
        const jToken = localStorage.getItem('jToken');
        const reqOptions = { headers: { Authorization: jToken } };

        await axiosApi.post(url, {pageNo: pageNo, pageSize: PAGE_SIZE }, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setDgnssList(prev => [...prev, ...res.data.result.dgnssList]);
                if (!res.data.result.hasNext) setHasNext(false);
            } else {
                setHasNext(false);
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
            setHasNext(false);
            console.error("주요진단 호출 중 오류  : ", err);
        })
    }, []);

    useEffect(() => {
        if (!isFirstApiCalled.current) {
        isFirstApiCalled.current = true;
        setTimeout(() => {
            retrieveUsrDgnssList(1);
        }, 50);
        }
    }, []);

    // ✅ pageNo 변경 시 (2 이상) 호출
    useEffect(() => {
        if (pageNo > 1 && hasNext) {
        retrieveUsrDgnssList(pageNo);
        }
    }, [pageNo]);

    // ✅ observer는 데이터가 렌더링된 이후에만 등록
    useEffect(() => {
        if (!hasNext || dgnssList.length === 0) return;

        // 기존 observer 제거
        if (scrollObserver.current && observerRef.current) {
        scrollObserver.current.unobserve(observerRef.current);
        }

        scrollObserver.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
            setPageNo(prev => prev + 1);
        }
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 1.0
        });

        if (observerRef.current) {
        scrollObserver.current.observe(observerRef.current);
        }

        return () => {
        if (scrollObserver.current && observerRef.current) {
            scrollObserver.current.unobserve(observerRef.current);
        }
        };
    }, [dgnssList.length, hasNext]);

    
    if(!dgnssList) return;
    
    return (
        <>
            <HeadSub title="주요 진단" />

                <div id="sub-content">
                    <div className='inner-wrap' data-pad="normal">

                    <div className={style['diagnosis-list-box']}>
                        <ul>
                            {dgnssList.length > 0 && 
                                dgnssList.map((item, _idx)=> {
                                    return (
                                    <li key={'dgnss_' + _idx}>
                                        <div className={style['head']}>
                                            <p>{item.dgnssKorNm ? item.dgnssKorNm : item.dgnssEngNm}</p>
                                            <p>{item.dgnssCd}</p>
                                        </div>
                                        <div className={style['bottom']}>
                                            <span>{item.dgnssDt}</span>
                                            <span>{item.hsptlNm}</span>
                                        </div>
                                    </li>
                                    )
                                })
                            }
                        </ul>  
                        <div ref={observerRef} style={{ height: '1px' }} />
                        </div>


                    </div>
                </div>
                {toast && (
                    <ToastPopup
                        setToast={setToast}
                        message={toastMessage}
                        position="center"
                        opacity="90"
                    />
                )}
            
        </>
    );
};

export default DiagnosisMore;
